import React from "react";
import { Select } from "antd";
import { FormInstance } from "antd/lib/form/hooks/useForm";
import { Nullable } from "../../../../../models/Common";
import { OptionMap } from "../../../../../helpers/optionMap";
import { FleetExpenseFormValues } from "../types";
import { formItemFactory } from "../../../../formItems/FormItemFactory";
import { DRIVER_SELECT_PREFIX } from "../constants";
import { searchByLabelProps } from "../selectSearchProps";
import validations from "../validations";

const FleetExpenseItem = formItemFactory<FleetExpenseFormValues>(validations);

type DriverSelectProps = {
  error: Nullable<string>;
  form: FormInstance<FleetExpenseFormValues>;
  isLoading: boolean;
  options: Nullable<OptionMap<string>>;
};

const DriverSelect = ({
  error,
  form,
  isLoading,
  options,
}: DriverSelectProps): React.ReactElement => (
  <FleetExpenseItem name="driver_id" label="Driver" extra={error ?? undefined}>
    <Select
      placeholder="Select Driver"
      options={options?.getSelectOptions(DRIVER_SELECT_PREFIX) ?? []}
      onChange={() => form.setFields([{ name: "driver_id", errors: [] }])}
      disabled={
        isLoading ||
        Boolean(error) ||
        !options ||
        options.getOptions().length === 0
      }
      loading={isLoading}
      notFoundContent={error ?? "No drivers available"}
      {...searchByLabelProps}
    />
  </FleetExpenseItem>
);

export default DriverSelect;
